import { Component, OnInit } from '@angular/core';
import { EndpointService } from '../../../../@shared/endpoints.service';
import { CompanyServiceOrderResponse } from '../../../../@shared/models/response.module';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-profile-invoices',
  standalone: false,
  templateUrl: './user-profile-invoices.html',
  styleUrl: './user-profile-invoices.css'
})
export class UserProfileInvoices implements OnInit {
  orders: CompanyServiceOrderResponse[] = [];
  loading: boolean = true;
  statusFilter: string = '';
  payingOrderId: number | null = null;

  constructor(
    private endpointService: EndpointService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.loadInvoices();
  }

  loadInvoices() {
    this.loading = true;
    const payload: any = {};
    if (this.statusFilter) {
      payload.status = this.statusFilter;
    }

    this.endpointService.csr_11(payload).subscribe({
      next: (res) => {
        this.orders = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.orders = [];
        this.loading = false;
      }
    });
  }

  onStatusFilterChange() {
    this.loadInvoices();
  }

  payInvoice(order: CompanyServiceOrderResponse) {
    this.payingOrderId = order.order_id;
    this.endpointService.csr_7(order.order_id).subscribe({
      next: (res) => {
        // Redirect to Stripe checkout
        window.location.href = res.data.checkout_url;
      },
      error: (err) => {
        console.error('Error creating payment session:', err);
        this.payingOrderId = null;
      }
    });
  }

  cancelSubscription(order: CompanyServiceOrderResponse) {
    if (confirm(this.translateService.instant('invoices.cancelSubscriptionConfirm'))) {
      this.endpointService.csr_10(order.order_id).subscribe({
        next: () => {
          this.loadInvoices();
        },
        error: (err) => {
          console.error('Error cancelling subscription:', err);
        }
      });
    }
  }

  formatPrice(cents: number): string {
    return (cents / 100).toFixed(2);
  }

  getOrderStatusClass(status: string): string {
    switch (status) {
      case 'paid':
        return 'badge-light-success';
      case 'pending':
        return 'badge-light-warning';
      case 'cancelled':
      case 'failed':
        return 'badge-light-danger';
      default:
        return 'badge-light-secondary';
    }
  }

  getStatusTranslation(status: string): string {
    switch (status) {
      case 'pending':
        return this.translateService.instant('invoices.pending');
      case 'paid':
        return this.translateService.instant('invoices.paid');
      case 'cancelled':
        return this.translateService.instant('invoices.cancelled');
      default:
        return status;
    }
  }

  getPaymentTypeLabel(type: string): string {
    return type === 'subscription'
      ? this.translateService.instant('invoices.subscription')
      : this.translateService.instant('invoices.oneTime');
  }

  getSubscriptionStatusTranslation(status: string): string {
    // For now, just capitalize - could add more translations if needed
    return status.charAt(0).toUpperCase() + status.slice(1);
  }

  isSubscriptionActive(order: CompanyServiceOrderResponse): boolean {
    return order.payment_type === 'subscription' &&
           order.status === 'paid' &&
           order.subscription_status === 'active';
  }
}
